import { render, staticRenderFns } from "./eb-tags-input.vue?vue&type=template&id=c28cec38&"
import script from "./eb-tags-input.vue?vue&type=script&lang=js&"
export * from "./eb-tags-input.vue?vue&type=script&lang=js&"
import style0 from "./eb-tags-input.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports